<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseBubble from './Base.vue';
import ActionCard from './ActionCard.vue';
import { CSAT_RATINGS, CSAT_DISPLAY_TYPES } from 'shared/constants/messages';
import { useMessageContext } from '../provider.js';

const { contentAttributes, content } = useMessageContext();
const { t } = useI18n();

const response = computed(
  () => contentAttributes.value?.submittedValues?.csatSurveyResponse ?? {}
);
const isRatingSubmitted = computed(() => !!response.value.rating);
const displayType = computed(
  () => contentAttributes.value?.displayType || CSAT_DISPLAY_TYPES.EMOJI
);
const isStarRating = computed(
  () => displayType.value === CSAT_DISPLAY_TYPES.STAR
);
const rating = computed(() => {
  if (!isRatingSubmitted.value) return null;
  return CSAT_RATINGS.find(
    csatOption => csatOption.value === response.value.rating
  );
});
const title = computed(
  () =>
    String(content.value || '').trim() || t('CONVERSATION.CSAT_REPLY_MESSAGE')
);
</script>

<template>
  <BaseBubble
    class="w-72 max-w-full !bg-n-slate-3 px-3.5 py-3"
    data-bubble-name="csat"
  >
    <ActionCard kind="rate" :title="title" />
    <dl v-if="isRatingSubmitted" class="mt-3 px-0.5">
      <dt class="text-xs italic text-n-slate-11">
        {{ t('CONVERSATION.RATING_TITLE') }}
      </dt>
      <dd v-if="!isStarRating" class="m-0 text-sm font-bold text-n-slate-12">
        {{ t(rating.translationKey) }}
      </dd>
      <dd v-else class="m-0 flex gap-1">
        <span
          v-for="n in 5"
          :key="n"
          :class="
            n <= (response.rating || 0)
              ? 'i-ph-star-fill text-n-amber-9'
              : 'i-ph-star text-n-slate-10'
          "
          class="size-4"
        />
      </dd>
      <template v-if="response.feedbackMessage">
        <dt class="mt-2 text-xs italic text-n-slate-11">
          {{ t('CONVERSATION.FEEDBACK_TITLE') }}
        </dt>
        <dd class="m-0 text-sm text-n-slate-12">
          {{ response.feedbackMessage }}
        </dd>
      </template>
    </dl>
  </BaseBubble>
</template>
